<template>
  <router-view/>
</template>

<script>
  export default {
    name: "NoPermissionComponent",
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$router.push(from);
        vm.$message({
          message: vm.$t('common.message.noPermission'),
          type: 'error',
          center: true
        });
      })
    }
  }
</script>

<style scoped>

</style>